import { Component, inject } from '@angular/core';
import { UserNotificationsService } from '../user-notifications.service';

@Component({
	selector: 'user-notifications-button',
	templateUrl: './user-notifications-button.component.html',
	standalone: false,
})
export class UserNotificationsButtonComponent {
	private service = inject(UserNotificationsService);

	notificationsCount = this.service.unreadCount;

	toggleNotifications() {
		this.service.toggleNotificationsOffcanvas();
	}
}
